import React from 'react';
import type { GridOwnProps } from '@mui/material/Grid/Grid';
import { Grid, Button, Typography } from '@mui/material';
import NoDataIllustration from '../Draw/NoDataIllustration';
import styled from '@emotion/styled';
import { convertStylesToStyled } from '@/_utils/utils';

interface TableNoResultsProps extends GridOwnProps {
  isClearable?: boolean;
  handleClearFilters?: () => void;
  maxHeight?: number;
}

const TableNoResults = ({ isClearable = false, handleClearFilters, maxHeight = 400, ...props }: TableNoResultsProps) => {
  return (
    <Wrapper container direction="column" alignItems="center" {...props}>
      <NoData style={{ maxHeight }}>
        <NoDataIllustration />
        <Typography variant="h6">No results found.</Typography>
        {isClearable && (
          <>
            <Typography sx={{ mb: 2 }}>Try adjusting your search or filters</Typography>
            <Button variant="outlined" color="primary" onClick={handleClearFilters}>
              Clear filters
            </Button>
          </>
        )}
      </NoData>
    </Wrapper>
  );
};

export default TableNoResults;

const Wrapper = styled(Grid)`
  ${({ theme }) => convertStylesToStyled(theme?.customOverrides?.TableNoResults)};
`;

const NoData = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.spacing(3)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  & > svg {
    width: 100%;
    max-width: 200px;
    opacity: 0.66;
    height: auto;
    margin-bottom: ${({ theme }) => theme.spacing(3)};
  }
  & h3 {
    opacity: 0.6;
  }
`;
